import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React from 'react';
import { useStyles } from '../styles';
import Search from '@material-ui/icons/Search';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const TicketDetailFilters = ({
  newAssetRequestCount,
  selectedCardCount,
  setCurrentView,
  filterOption,
  setFilterOption,
  assetType,
  searchText,
  handleSearchChange,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 1453px)');
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const handleCheckStatus = () => {
    setCurrentView('StatusPage');
  };

  return (
    <>
      {!isMobile && (
        <div>
          <FormControl>
            <InputLabel shrink variant="outlined">
              All Assets
            </InputLabel>
            <Select
              label="All Assets"
              variant="outlined"
              id="assetType"
              className={classes.filterDropdown}
              classes={{ root: classes.filterPadding }}
              onChange={(val: any) => {
                setFilterOption({
                  ...filterOption,
                  assetType: val.target.value,
                });
              }}
              value={filterOption.assetType}
            >
              {assetType &&
                assetType.map((t: string) => (
                  <MenuItem key={`type-option-${t}`} value={t}>
                    {t}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <TextField
            variant="outlined"
            type="search"
            className={classes.searchInTicketsPage}
            value={searchText}
            onChange={handleSearchChange}
            placeholder="Search reusable libraries"
            // InputProps={{ endAdornment: !searchText && <Search /> }}
            InputProps={{ endAdornment: !searchText && <Search /> }}
          />
        </div>
      )}
    </>
  );
};

export default TicketDetailFilters;
